import React from 'react'

type HistogramIconProps = {
    filledIndex?: 0 | 1 | 2 // bar to fill with color
    fillColor?: string // default is blue
    size?: number // width and height
}

const HistogramIcon: React.FC<HistogramIconProps> = ({ filledIndex, fillColor = 'blue', size = 24 }) => {
    const barFills = ['gray', 'gray', 'gray']
    if (filledIndex !== undefined) {
        barFills[filledIndex] = fillColor
    }

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="black"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="3" y="14" width="4" height="7" stroke="black" fill={barFills[0]} />
            <rect x="10" y="10" width="4" height="11" stroke="black" fill={barFills[1]} />
            <rect x="17" y="6" width="4" height="15" stroke="black" fill={barFills[2]} />
        </svg>
    )
}

export default HistogramIcon
